<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 20"
    fill="none"
    v-bind="$attrs"
    :width="width"
    :height="height"
  >
    <path
      d="M5.233 4.4506L5.678 2.4472C5.76866 2.039 6.01371 1.67169 6.37144 1.40783C6.72918 1.14396 7.17747 0.999835 7.64 1H14.36C14.8225 0.999835 15.2708 1.14396 15.6286 1.40783C15.9863 1.67169 16.2313 2.039 16.322 2.4472L16.767 4.4506C16.8369 4.76451 17.0043 5.05413 17.2498 5.28579C17.4953 5.51744 17.8089 5.68161 18.154 5.7592C18.967 5.94224 19.6887 6.36461 20.2044 6.95917C20.72 7.55373 21.0001 8.28635 21 9.0406V15.4C21 16.3548 20.5786 17.2705 19.8284 17.9456C19.0783 18.6207 18.0609 19 17 19H5C3.93913 19 2.92172 18.6207 2.17157 17.9456C1.42143 17.2705 1 16.3548 1 15.4V9.0406C0.999924 8.28635 1.27998 7.55373 1.79564 6.95917C2.31131 6.36461 3.033 5.94224 3.846 5.7592C4.19111 5.68161 4.50466 5.51744 4.75019 5.28579C4.99572 5.05413 5.16315 4.76451 5.233 4.4506V4.4506Z"
      :stroke="stroke"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11 14.1992C12.6569 14.1992 14 12.8561 14 11.1992C14 9.54236 12.6569 8.19922 11 8.19922C9.34315 8.19922 8 9.54236 8 11.1992C8 12.8561 9.34315 14.1992 11 14.1992Z"
      :stroke="stroke"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 4.59961H12"
      :stroke="stroke"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script lang="ts" setup>
defineProps({
  width: {
    type: [String, Number],
    default: 22,
  },
  height: {
    type: [String, Number],
    default: 20,
  },
  stroke: {
    type: String,
    default: '#1C5691',
  },
  strokeWidth: {
    type: [String, Number],
    default: '2',
  },
});
</script>

